import styled from 'styled-components'

type TipsMarkProps = {
  $pos: 'left' | 'right';
}
export const TipsMark = styled.div<TipsMarkProps>`
  display: inline-block;
  position: relative;

  & div.tips {
    position: absolute;
    top: 0;
    left: ${({$pos}) => ($pos === 'right') ? '50%':'auto'};
    right: ${({$pos}) => ($pos === 'left') ? '50%':'auto'};
    transform: translateY(calc(-100% - 4px));
    width: 176px;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid rgba(24, 24, 24, 0.20);
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    
    color: rgba(24, 24, 24, 0.50);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;

    display: none;
  }
  &:hover div.tips {
    display: block;
  }
  & div.tips > p {
    text-align: left;
  }
`
